module.exports = __webpack_public_path__ + "img/acc13.5bf13139.png";